/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable

import React, { useEffect } from 'react';

import { Grid, Stack, Typography } from '@mui/material';

import { isNative } from '../../utils/mobile';
import theme from '../../utils/theme';
import { Mixpanel, MIXPANEL_TAGS } from '../../utils/mixpanel';

const ServicoInterrompido = () => {
  const isBusinessUrl = window.location.href.includes(process.env.REACT_APP_BUSINESS) || window.location.href.includes(process.env.REACT_APP_SIGN);

  useEffect(() => {
    if (isBusinessUrl || isNative) {
      return;
    }
    Mixpanel.track(MIXPANEL_TAGS.LANDING_VIEW);
  }, [isBusinessUrl, isNative]);

  if (isBusinessUrl || isNative) {
    return null;
  }

  return (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justifyContent='center'
      style={{
        minHeight: '100vh',
        padding: '20px',
        backgroundColor: theme.backgroundDefault,
      }}
    >
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <Stack spacing={4} alignItems='center' textAlign='center'>
          <Typography
            variant='h1'
            color={theme.GUIAVET}
            fontSize={{ xs: 32, md: 48 }}
            fontWeight={600}
          >
            Serviço indisponível
          </Typography>

          <Typography
            variant='body1'
            color={theme.MEDIUM_NAVY}
            fontSize={{ xs: 16, md: 20 }}
            style={{ maxWidth: '600px' }}
          >
            A plataforma não está mais disponível.
            <br />
            Para mais informações, envie um e-mail para <span style={{ color: theme.GUIAVET }}>suporte@guia.vet</span>.
          </Typography>

          {/* <a
            href='https://go.guia.vet/helpcenter'
            target='_blank'
            rel='noopener noreferrer'
            style={{
              marginTop: '24px',
              padding: '16px 40px',
              fontSize: '20px',
              fontWeight: 600,
              backgroundColor: theme.primaryButton,
              borderRadius: theme.buttonRadius,
              color: theme.fontColorLight,
              textDecoration: 'none',
              display: 'inline-block',
              cursor: 'pointer',
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = '0.9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = '1';
            }}
          >
            Acessar canal de suporte
          </a> */}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ServicoInterrompido;
